/**
 * @Author: abbeymart | Abi Akindele | @Created: 2020-10-17
 * @Company: Copyright 2020 Abi Akindele  | mConnect.biz
 * @License: All Rights Reserved | LICENSE.md
 * @Description: policy routes map
 */

import type { RouteRecordRaw } from 'vue-router';

export const policyRoutes: Array<RouteRecordRaw> = [
  {
    path: '/policy',
    name: 'policy',
    redirect: '/policy/list',
    component: () => import('pages/micros/pa/policy/McPolicy.vue'),
    meta: {
      title: 'Policies',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'policyList',
        component: () => import('pages/micros/pa/policy/PolicyList.vue'),
        meta: {
          title: 'Policies List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'policyDetail',
        component: () => import('pages/micros/pa/policy/PolicyDetail.vue'),
        meta: {
          title: 'Policy Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'policyNew',
        component: () => import('pages/micros/pa/policy/PolicyNew.vue'),
        meta: {
          title: 'New Policy',
          requiresAuth: true,
        },
      },
      {
        path: 'report',
        name: 'policyReport',
        component: () => import('pages/micros/pa/policy/PolicyReport.vue'),
        meta: {
          title: 'Policy Reports',
          requiresAuth: true,
        },
      },
      {
        path: 'model',
        name: 'policyModel',
        component: () => import('pages/micros/pa/policy/PolicyModel.vue'),
        meta: {
          title: 'Policy Models',
          requiresAuth: true,
        },
      },
      {
        path: 'rule',
        name: 'policyRule',
        component: () => import('pages/micros/pa/policy/PolicyRule.vue'),
        meta: {
          title: 'Policy Rule Computation [Testing]',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/appPolicy',
    name: 'appPolicy',
    redirect: '/appPolicy/list',
    component: () => import('pages/micros/pa/appPolicy/AppPolicy.vue'),
    meta: {
      title: 'Application Policies',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'appPolicyList',
        component: () => import('pages/micros/pa/appPolicy/AppPolicyList.vue'),
        meta: {
          title: 'Application Policies List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'appPolicyDetail',
        component: () => import('pages/micros/pa/appPolicy/AppPolicyDetail.vue'),
        meta: {
          title: 'Application Policy Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'appPolicyNew',
        component: () => import('pages/micros/pa/appPolicy/AppPolicyNew.vue'),
        meta: {
          title: 'New Application Policy',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/pGroup',
    name: 'pGroup',
    redirect: '/pGroup/list',
    component: () => import('pages/micros/pa/pGroup/PGroup.vue'),
    meta: {
      title: 'Groups (policy)',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'pGroupList',
        component: () => import('pages/micros/pa/pGroup/PGroupList.vue'),
        meta: {
          title: 'Groups (policy) List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'pGroupDetail',
        component: () => import('pages/micros/pa/pGroup/PGroupDetail.vue'),
        meta: {
          title: 'Group (policy) Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'pGroupNew',
        component: () => import('pages/micros/pa/pGroup/PGroupNew.vue'),
        meta: {
          title: 'New Group (policy)',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/pItem',
    name: 'pItem',
    redirect: '/pItem/list',
    component: () => import('pages/micros/pa/pItem/PItem.vue'),
    meta: {
      title: 'Items (policy)',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'pItemList',
        component: () => import('pages/micros/pa/pItem/PItemList.vue'),
        meta: {
          title: 'Items List (policy)',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'pItemDetail',
        component: () => import('pages/micros/pa/pItem/PItemDetail.vue'),
        meta: {
          title: 'Item Details (policy)',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'pItemNew',
        component: () => import('pages/micros/pa/pItem/PItemNew.vue'),
        meta: {
          title: 'New Item (policy)',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/policyGroup',
    name: 'policyGroup',
    redirect: '/policyGroup/list',
    component: () => import('pages/micros/pa/policyGroup/PolicyGroup.vue'),
    meta: {
      title: 'Policy Groups',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'policyGroupList',
        component: () => import('pages/micros/pa/policyGroup/PolicyGroupList.vue'),
        meta: {
          title: 'Policy Groups List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'policyGroupDetail',
        component: () => import('pages/micros/pa/policyGroup/PolicyGroupDetail.vue'),
        meta: {
          title: 'Policy Group Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'policyGroupNew',
        component: () => import('pages/micros/pa/policyGroup/PolicyGroupNew.vue'),
        meta: {
          title: 'New Policy Group',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/pGroupItem',
    name: 'pGroupItem',
    redirect: '/pGroupItem/list',
    component: () => import('pages/micros/pa/pGroupItem/PGroupItem.vue'),
    meta: {
      title: 'Group Items (policy)',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'pGroupItemList',
        component: () => import('pages/micros/pa/pGroupItem/PGroupItemList.vue'),
        meta: {
          title: 'Group Items List (policy)',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'pGroupItemDetail',
        component: () => import('pages/micros/pa/pGroupItem/PGroupItemDetail.vue'),
        meta: {
          title: 'Group Item Details (policy)',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'pGroupItemNew',
        component: () => import('pages/micros/pa/pGroupItem/PGroupItemNew.vue'),
        meta: {
          title: 'New Group Item (policy)',
          requiresAuth: true,
        },
      },
    ],
  },
];
